/**
 * App-minted install identifier for the data platform.
 *
 * A random UUID generated once on first run and persisted in localStorage,
 * reused for the life of the install. Deliberately NOT an OS/hardware id — an
 * app-scoped random UUID is privacy-clean and sufficient to attribute and dedup
 * events (especially anonymous / pre-login opens, which carry no user_id).
 *
 * Sent on every event as the `X-Device-Id` header; the ingest Lambda extracts it
 * into `metadata.device_id`. It is preserved across `clearStorage()` (see
 * Function.js) so it survives logout and the SSO callback's storage wipe —
 * without that, the anonymous open and the following sign-in would carry
 * different ids and could not be stitched together.
 */

export const DEVICE_ID_KEY = "wone_device_id";

/**
 * The stable install id, minting and persisting it on first call. Returns null
 * only if localStorage is unavailable and no id could be generated — callers
 * treat that as "no device_id header" rather than failing the emit.
 */
export function getDeviceId(): string | null {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing) return existing;

  const minted = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, minted);
  return minted;
}
